import React from 'react';
import { omitBy, isEmpty } from 'lodash/fp';
import { Icon } from 'ui';
import { mapWithIndexes } from 'utils/fp';

const BOOTSTRAP_TOOLTIP_LENGTH_THRESHOLD = 30;

const ControlButton = ({
  icon,
  tooltip,
  tooltipStyle,
  connectDragSource,
  count,
  labelForId,
  ...props
}) => {
  const ControlTag = connectDragSource ? 'div' : 'button';
  let tooltipProps;
  if (tooltip) {
    // switching to bootstrap tooltips if the tooltip text length is greater
    // than the threshold
    tooltipProps =
      tooltip.length > BOOTSTRAP_TOOLTIP_LENGTH_THRESHOLD
        ? {
            title: tooltip,
            'data-toggle': 'tooltip',
            className: 'EditorElement-controlButton',
          }
        : {
            'data-tooltip': tooltip,
            className: 'EditorElement-controlButton ButtonWithTooltip',
          };
  }
  const button = (
    <ControlTag {...props} {...tooltipProps}>
      {!!labelForId && (
        <label htmlFor={labelForId}>
          <Icon name={icon} />
        </label>
      )}
      {!labelForId && <Icon name={icon} />}
      {!!count && (
        <div
          className="EditorElement-controlButtonCount"
          children={count >= 100 ? '99+' : count}
        />
      )}
    </ControlTag>
  );

  return connectDragSource
    ? connectDragSource(button, { dropEffect: 'move', effectAllowed: 'move' })
    : button;
};

const renderControls = mapWithIndexes((control, i) => (
  <ControlButton {...control} key={i} />
));

const ElementControls = ({ id, controls }) => (
  <div className="EditorElement-controls">
    {renderControls(omitBy(isEmpty, controls))}
  </div>
);

export default ElementControls;
